export default "__VITE_ASSET__kUFXNAyE__"